import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export const Container = styled.div`
  padding: ${primitive.$spacing4} 0;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.span`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.heavy};
  font-size: 1rem;
  color: ${primitive.th.$coffeeBrown};
`;

export const SubTitle = styled.span`
  font-family: ${Styles.fontFamily.body};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 0.85rem;
  color: ${primitive.th.$coffeeBrown};
`;
